import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import getters from './getters'
import layout from './modules/layout';
import suprazones from './modules/suprazones'
import pickupzones from './modules/pickupzones'
import subzones from './modules/subzones'
import geopoints from './modules/geopoints'
import filters from './modules/filters'
import buses from './modules/buses'
import bookings from './modules/bookings'
import groups from './modules/groups'
import stops from './modules/stops'
import trekksoft from './modules/trekksoft'
import loading from './modules/loading';
import sendgrid from './modules/sendgrid';
import hotels from './modules/hotels';
import bookingsBus from './modules/bookingsBus';
import dashboard from './modules/dashboard';
import activities from './modules/activities';
import guides from './modules/guides';
import analytics from './modules/analytics'
import buscompanies from './modules/buscompanies'
import busFareTypes from './modules/busFareTypes' 
import buscompaniesprices from './modules/buscompaniesprices'
import activityDurationTypes from './modules/activityDurationTypes'
import hotelStopGroups from './modules/hotelStopGroups'
import zerotours from './modules/zerotours'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    layout,
    suprazones,
    pickupzones,
    subzones,
    geopoints,
    filters,
    buses,
    bookings,
    groups,
    stops,
    trekksoft,
    loading,
    sendgrid,
    hotels,
    bookingsBus,
    dashboard,
    activities,
    guides,
    analytics,
    buscompanies,
    busFareTypes,
    buscompaniesprices,
    activityDurationTypes,
    hotelStopGroups,
    zerotours
  },
  getters,
  plugins: [
    createPersistedState({
      key: 'filters',
      paths: ['filters'],
    }),
  ],
})

export default store